import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from '../services/user-service/user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { MainService } from '../services/optimizer-service/optimizer.service';

@Component({
  selector: 'app-delivery-rating-dialog',
  templateUrl: './delivery-rating-dialog.component.html',
  styleUrls: ['./delivery-rating-dialog.component.css']
})
export class DeliveryRatingDialogComponent implements OnInit {

  errorMessage = null;
  readOnly = false;
  hideComment = false;
  showNumbers = false;
  payload = {
    customerid: null,
    name: null,
    rating: 0,
    driver: 0,
    recommend: 0,
    comment: "",
    surveys: 0
  };
  submitted;
  constructor(private mainService: MainService, private dialog: MatDialog,
    public dialogRef: MatDialogRef<DeliveryRatingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.readOnly = data.readOnly || false;
    this.hideComment = data.hideComment || false;
    this.showNumbers = data.showNumbers || false;

    if (this.readOnly && data.trip) {
      // Load existing rating data for read-only mode

      const rating = data.trip.rating;
      this.payload.rating = rating.rating || 0;
      this.payload.driver = rating.driver || 0;
      this.payload.recommend = rating.recommend || 0;
      this.payload.comment = rating.comment || "";
      this.payload.surveys = rating.surveys || 0;
    } else if (data.trip.tripid) {
      // Normal mode - set tripid for submission
      this.data.trip.tripid = data.trip.tripid;
    }
  }

  ngOnInit() {
    // In read-only mode, prevent any changes to the payload
    if (this.readOnly) {
      // Freeze the payload object to prevent modifications
      Object.freeze(this.payload);
    }
  }

  // Prevent rating changes in read-only mode
  onRatingChange() {
    if (this.readOnly) {
      // If somehow a change occurs, revert it
      return false;
    }
    return true;
  }

  // Prevent any clicks on rating components in read-only mode
  preventClick(event: Event) {
    if (this.readOnly) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  submit() {
    if (this.readOnly) {
      // In read-only mode, just close the dialog
      this.dialogRef.close();
      return;
    }

    this.errorMessage = "";
    if (this.payload.recommend == 0 || this.payload.driver == 0 || this.payload.rating == 0 || this.payload.comment == "") {
      this.errorMessage = "Please give a rating to each category and leave a comment";
      return;
    }
    this.mainService.rateTrip(this.data.trip.tripid, this.payload).then((result: any) => {
      if (result.status) {
        this.submitted = "Your rating and comment have been submitted. Thank you!"
        setTimeout(() => {
          this.dialogRef.close({
            message: "Thanks you for your feedback regarding this trip.",
            title: "Thank you"
          });
        }, 4000);
      } else {

        if (result.code == 100) {
          this.errorMessage = "You are not allowed to rate the trip until the drop off time has elapsed. Please try again in day or a couple hours.";
        } else {
          this.errorMessage = "There was a problem when rating the trip. Please try again later.";
        }

      }

    }).catch(e => {
      this.errorMessage = "There was a problem when rating the trip. Please try again later.";;
    });
  }

}
